/** Per-viewer conveniences of the Library (a remembered scale or filter); storage may be unavailable. */
export function readPref(key: string): string | null {
  try {
    return localStorage.getItem(`solaros.${key}`);
  } catch {
    return null;
  }
}

export function writePref(key: string, value: string): void {
  try {
    localStorage.setItem(`solaros.${key}`, value);
  } catch {
    /* private mode */
  }
}
